import React from "react";
import styled from "styled-components";
import { WHEN_LG, WHEN_MD, WHEN_XL, PALETTE } from "../constants";
import Heading from "./SectionHeading";
import Subheading from "./SectionSubheading";
import { StaticImage } from "gatsby-plugin-image";
import PricingCard from "./PricingCard";
import ContentContainer from "./ContentContainer";

const OuterContainer = styled(ContentContainer)``;

const TitleContainer = styled.div``;

const BodyContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 3rem;
  flex-direction: column;
  ${WHEN_MD} {
    flex-direction: row;
  }
`;

const PricingContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 4rem;
  flex-direction: column;
  text-align: left;

  ${WHEN_MD} {
    flex-direction: row;
    margin: 0;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 350px;
`;

const ContentContainerInner = styled.div`
  text-align: center;
  ${WHEN_MD} {
    text-align: left;
  }
`;

export default function Pricing() {
  return (
    <OuterContainer id="pricing">
      <BodyContainer>
        <ContentContainerInner>
          <TitleContainer className="mb-4">
            <Heading>Pricing</Heading>
            <StaticImage
              src="../images/product-showcase-1-stroke.svg"
              alt="stroke"
              placeholder="blurred"
              objectFit="contain"
              width={225}
              height={13}
            />
          </TitleContainer>
          <PricingContainer>
            <PricingCard
              backgroundColor={PALETTE.PRIMARY[500]}
              iconImage="🆓"
              price="FREE"
              period="For 30 days"
              description="Try NoFi risk free. Cancel at any time."
            />
            <PricingCard
              backgroundColor={PALETTE.PRIMARY[600]}
              iconImage="🤖"
              price="$9.99"
              period="per month"
              description="Our standard (and only) pricing tier. Cancel at any time."
            />
          </PricingContainer>
        </ContentContainerInner>

        <ImageContainer>
          <StaticImage
            src="../images/undraw-empty-cart.svg"
            alt="shopping cart"
            placeholder="blurred"
            objectFit="contain"
          />
        </ImageContainer>
      </BodyContainer>
    </OuterContainer>
  );
}
